// Test IDs for base style carousel component

export const BASE_STYLE_CAROUSEL_TEST_IDS = {
  HEADER: 'base-style-header',
  CAROUSEL: 'base-style-carousel',
  SLIDE_BUTTONS: 'slide-buttons',
  DESCRIPTION: 'base-style-description',
  CONFIRM_BTN: 'base-style-confirm-btn',
  getStyleImage: (styleName: string) => `base-style-${styleName}-image`,
  getStyleId: (styleId: string) => `base-style-${styleId}-id`,
  getStyleName: (styleName: string) => `base-style-${styleName}-name`,
} as const;

